module.exports = __webpack_public_path__ + "img/sbwx.png";